import React, { createRef, useEffect } from 'react';
import styles from './mediaOverlay.scss';
import { inject, observer } from 'mobx-react';
import { IMixedMediaStore } from '../../types';
import { MainImage } from '../mixedMedia/element_1/mainImage';
import CrossRing from '../icons/crossRing';
import TabNavigationHelper from '../../helper/tabNavigationHelper';
import { unlockBodyScroll } from '../../hooks/useBodyScrollLock';

export const MediaOverlay = inject('mixedMediaStore')(
    observer(({ mixedMediaStore }: IMixedMediaStore) => {
        const closeButtonRef = createRef<HTMLDivElement>();
        const tabNavigation = TabNavigationHelper.instance;

        function closeMediaOverlay(): void {
            const lockEventSource = 'PDP.MediaOverlay';
            mixedMediaStore?.updateMediaOverlayVisibility(false);
            unlockBodyScroll(lockEventSource);
            mixedMediaStore?.mainStore.showEsAppButton();
        }

        useEffect(() => {
            tabNavigation.setFocusAtt(closeButtonRef.current);
            if(mixedMediaStore?.displayMediaOverlay){
                window.shell.tabNav.focus(closeButtonRef.current as Element);
                window.shell.tabNav.onActivated('.pdp-cross_icon', () => {
                    const zoomButton = document.querySelector('[data-testid="pdp-zoom-button"]');
                    if(zoomButton)
                    window.shell.tabNav.focus(zoomButton);
                })
            }

        }, [mixedMediaStore?.displayMediaOverlay]);

        if (mixedMediaStore?.displayMediaOverlay)
            return (
                <div className={styles.mediaoverlay} data-testid='pdp-mediaoverlay' data-semantic-id='pdp-mediaoverlay'
                    ref={(el) => tabNavigation.setModalAtt(el)}>
                    <div className={styles.cross_icon} onClick={closeMediaOverlay} data-testid='pdp-mo-close'
                      data-semantic-id='pdp-mo-close'
                        ref={closeButtonRef}
                        onKeyDown={tabNavigation.handleKeyDown}>
                        <CrossRing />
                    </div>
                    <MainImage />
                </div>)
        else
            return null;
    })
);

